<template>
  <div>
    <div v-if="options && broker">
      <v-dialog
        v-model="dialogs.testWarning"
        scrollable
        persistent
        max-width="400"
      >
        <material-card
        :title="$t('views.plans.test')"
          :color="$vuetify.theme.themes.light.warning"
          icon="science"
        >
          <v-card-text>
            {{ $t("views.planwizardview.test_warning_message") }}
          </v-card-text>
          <v-card-actions>
            <v-btn
              :loading="saving"
              color
              text
              @click="dialogs.testWarning = false"
            >
              {{ $t("globals.cancel") }}
            </v-btn>
            <v-btn :loading="saving" color="primary" text @click="testDraft">
              {{ $t("views.plans.go_to_test_mode") }}
            </v-btn>
          </v-card-actions>
        </material-card>
      </v-dialog>
      <v-dialog v-model="dialogs.import" scrollable persistent max-width="400">
        <material-card
        :title="$t('globals.import')"
          :color="$vuetify.theme.themes.light.success"
          icon="file_upload"
        >
          <v-card-text>
            <!-- <auto-select
              :value.sync="planType"
              :items="options.Enums.PlanType"
              :label="
                $t('components.brokersplans.plancreationdialog.plan_type')
              "
              :rules="[$rules.required]"
              :slots="true"
              :filter="filterFunc"
            >
              <template v-slot:selection="data">
                {{ $t("enums." + data.item) }}
              </template>
              <template v-slot:item="data">
                <v-list-item-content
                  v-text="$t('enums.' + data.item)"
                ></v-list-item-content>
              </template>
            </auto-select> -->
            <trans-enum
              :value.sync="planType"
              :items="options.Enums.PlanType"
              :label="
                $t('components.brokersplans.plancreationdialog.plan_type')
              "
              :rules="[$rules.required]"
              class="required"
            ></trans-enum>
            <file-uploader
              v-if="planType"
              ref="uploader"
              :label="$t('views.plans.import_select')"
              accept=".json"
              :uploading="uploading"
              :url="uploadURL"
              v-on:upload-started="onUploadStarted"
              v-on:upload-error="onUploadError"
              v-on:upload-completed="onUploadCompleted"
              :mustLock="false"
            ></file-uploader>
            <div v-if="uploaded">
              <v-banner
                v-if="uploadedOK"
                icon="done"
                color="success"
                elevation="0"
                icon-color="white"
              >
                {{ $t("views.plans.upload_success") }}
              </v-banner>
              <v-banner
                v-else
                icon="error"
                color="error"
                elevation="0"
                icon-color="white"
              >
                {{ $t("views.plans.upload_fail") }}
              </v-banner>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :loading="saving" color text @click="closeImport">
              {{ $t("globals.close") }}
            </v-btn>
          </v-card-actions>
        </material-card>
      </v-dialog>
      <v-dialog v-model="dialogs.delete" scrollable persistent max-width="400">
        <material-card
          :title="$t('views.plans.remove_draft')"
          :color="$vuetify.theme.themes.light.error"
          icon="delete_forever"
        >
          <v-card-text>
            {{ $t("views.plans.are_you_sure") }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              :loading="saving"
              color
              text
              @click="
                planId = null;
                dialogs.delete = false;
              "
            >
              {{ $t("globals.cancel") }}
            </v-btn>
            <v-btn :loading="saving" color="error" text @click="removePlan">
              {{ $t("globals.delete") }}
            </v-btn>
          </v-card-actions>
        </material-card>
      </v-dialog>
      <v-dialog
        v-model="dialogs.activateWarning"
        scrollable
        persistent
        max-width="400"
      >
        <material-card
        :title="$t('views.plans.activate')"
          :color="$vuetify.theme.themes.light.success"
          icon="publish"
        >
          <v-card-text>
            {{ $t("views.planwizardview.activate_warning_message") }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              :loading="saving"
              color
              text
              @click="
                selectedItem = null;
                dialogs.activateWarning = false;
              "
            >
              {{ $t("globals.cancel") }}
            </v-btn>
            <v-btn :loading="saving" color="success" text @click="finalize">
              {{ $t("views.plans.activate") }}
            </v-btn>
          </v-card-actions>
        </material-card>
      </v-dialog>
      <v-dialog
        v-model="dialogs.draftWarning"
        scrollable
        persistent
        max-width="400"
      >
        <material-card
          :title="$t('views.plans.revert_to_draft')"
          :color="$vuetify.theme.themes.light.error"
          icon="build"
        >
          <v-card-text>
            {{ $t("views.plangeneralparameters.warning_message") }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              :loading="saving"
              color
              text
              @click="
                selectedItem = null;
                dialogs.draftWarning = false;
              "
            >
              {{ $t("globals.cancel") }}
            </v-btn>
            <v-btn :loading="saving" color="warning" text @click="tryMakeDraft">
              {{ $t("views.plans.revert_to_draft") }}
            </v-btn>
          </v-card-actions>
        </material-card>
      </v-dialog>
      <v-dialog
        v-model="dialogs.clearDataWarning"
        scrollable
        persistent
        max-width="400"
      >
        <material-card
          :title="$t('views.plans.clear_data')"
          :color="$vuetify.theme.themes.light.warning"
          icon="clear"
        >
          <v-card-text>
            {{ $t("views.plans.clear_data_warning_message") }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              :loading="saving"
              color
              text
              @click="
                selectedItem = null;
                dialogs.clearDataWarning = false;
              "
            >
              {{ $t("globals.cancel") }}
            </v-btn>
            <v-btn :loading="saving" color="warning" text @click="tryClearData">
              {{ $t("views.plans.clear_data") }}
            </v-btn>
          </v-card-actions>
        </material-card>
      </v-dialog>
      <v-dialog scrollable v-model="loading" persistent max-width="200">
        <v-card>
          <v-card-title>{{ $t("globals.please_wait") }}</v-card-title>
          <v-card-text>
            <v-container fluid grid-list-md>
              <v-layout row justify-center>
                <v-flex xs12 sm6 md4 lg3>
                  <v-progress-circular indeterminate></v-progress-circular>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <plan-creation-dialog
        :model="dialogs.create"
        @close="
          dialogs.create = false;
          $refs.table.getDataAsync();
        "
        :broker="broker"
      />
      <material-card
        v-if="broker !== null || broker !== undefined"
        :title="$t('globals.plans')"
        :color="$vuetify.theme.themes.light.secondary"
        icon="file_copy"
      >
        <pbas-data-table
          ref="table"
          :exporters="$exporters"
          :dataProvider="provider"
          :showSelect="false"
          :floatActions="floatActions"
          :rowActions="rowActions"
          identifier="plansTable"
          sortBy="UniqueIdentifier"
          @error="error = $event"
        ></pbas-data-table>
        <v-snackbar
          v-model="snackbar"
          :color="color"
          :multi-line="mode === 'multi-line'"
          :timeout="timeout"
          :vertical="mode === 'vertical'"
        >
          {{ message }}
          <v-btn dark text @click="snackbar = false">
            {{ $t("globals.close") }}
          </v-btn>
        </v-snackbar>
      </material-card>
      <error-handler :error="error"></error-handler>
    </div>
    <div v-else>
      <v-row justify="center">
        <v-progress-circular
          :size="70"
          :width="7"
          color="accent"
          indeterminate
        ></v-progress-circular>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ODataProvider } from "pbas-vue-components";
import getPlansHeaders from "../headers/Plans";
import ErrorHandler from "../components/ErrorHandler";
import { locker } from "../mixins/locker";
import FileUploader from "../components/FileUploader";
import PlanCreationDialog from "../components/BrokersPlans/PlanCreationDialog.vue";
import AutoSelect from "../components/AutoSelect.vue";
import TransEnum from "../components/TransEnum.vue";

export default {
  name: "plans-table",
  components: {
    ErrorHandler,
    FileUploader,
    PlanCreationDialog,
    AutoSelect,
    TransEnum,
  },
  mixins: [locker],
  data() {
    return {
      uploadURL: null,
      uploadedOK: false,
      uploaded: false,
      uploading: false,
      loading: false,
      broker: null,
      error: null,
      provider: undefined,
      saving: false,
      selectedItem: null,
      floatActions: [
        {
          text: "views.plans.build_plan",
          name: "add",
          icon: "build",
          color: this.$vuetify.theme.themes.light.success,
          handler: () => {
            this.dialogs.create = true;
          },
        },
        {
          text: "globals.import",
          name: "import",
          icon: "file_upload",
          color: this.$vuetify.theme.themes.light.primary,
          handler: async () => {
            this.dialogs.import = true;
          },
        },
      ],
      rowActions: [
        {
          name: "edit",
          icon: "edit",
          title: "globals.edit",
          handler: async (item) => {
            this.$router.push({
              name: "planWizardView",
              params: {
                broker: this.broker.Id,
                plan: item.Id,
                status: item.Status,
              },
            });
          },
          visible: (item) => item.Status === "Draft",
        },
        {
          name: "clearData",
          icon: "clear",
          title: "Clear Data",
          handler: async (item) => {
            this.selectedItem = item;
            this.dialogs.clearDataWarning = true;
          },
          visible: (item) => item.Status === "Testing",
        },
        {
          name: "makeTest",
          icon: "science",
          title: "views.plans.test",
          handler: (item) => {
            this.selectedItem = item;
            this.dialogs.testWarning = true;
          },
          visible: (item) => item.Status === "Draft" && item.IsValid,
        },
        {
          name: "makeDraft",
          icon: "build",
          title: "views.plans.make_draft",
          handler: (item) => {
            this.selectedItem = item;
            this.dialogs.draftWarning = true;
          },
          visible: (item) =>
            item.Status === "Testing" || item.Status === "Live",
        },
        {
          name: "activate",
          icon: "publish",
          title: "views.plans.activate",
          handler: (item) => {
            this.selectedItem = item;
            this.dialogs.activateWarning = true;
          },
          visible: (item) =>
            item.Status === "Testing" ||
            (item.Status === "Draft" && item.IsValid),
        },
        {
          name: "export",
          icon: "file_download",
          title: "globals.export",
          handler: async (item) => this.tryExport(item),
        },
        {
          name: "delete",
          icon: "delete_forever",
          title: "globals.delete",
          handler: (item) => {
            this.planId = item.Id;
            this.dialogs.delete = true;
          },
          visible: (item) => item.Status === "Draft",
        },
        // {
        //   name: "makeDraftFromLive",
        //   icon: "build",
        //   title: "views.plans.make_draft",
        //   handler: (item) => {
        //     this.selectedItem = item;
        //     this.dialogs.draftWarning = true;
        //   },
        //   visible: (item) => item.Status === "Live",
        // },
        // {
        //   name: "editCoverage",
        //   icon: "edit",
        //   title: "Edit Coverage",
        //   handler: async (item) => {
        //     this.$router.push({
        //       name: "planRenewWizard",
        //       params: { plan: item.Id },
        //     });
        //   },
        //   visible: (item) => false, //item.Status === "Active",
        // },
      ],
      tableTitle: "Plans",
      dialogs: {
        add: false,
        delete: false,
        finalize: false,
        draftWarning: false,
        activateWarning: false,
        import: false,
        create: false,
        testWarning: false,
        clearDataWarning: false,
      },
      selected: [],
      snackbar: false,
      color: "",
      mode: "",
      timeout: 2500,
      message: "",
      headers: null,
      planId: null,
      planType: null,
    };
  },
  computed: {
    ...mapGetters("odata", { storeSearch: "search" }),
    ...mapGetters("plansMembers", ["options"]),
    ...mapGetters("auth", ["isLoggedIn", "user", "role"]),
    ...mapGetters("common", ["language", "settings"]),
  },
  watch: {
    broker: {
      async handler(v) {
        console.log("broker: ", this.headers, this.broker);
        if (v && this.headers) {
          this.provider = new ODataProvider(
            this.$axiosHttp,
            "brokers/" + v.Id + "/draft-plans",
            this.headers
          );
        }
      },
    },
    headers: {
      async handler(v) {
        console.log("headers: ", this.headers, this.broker);
        if (v && this.broker) {
          this.provider = new ODataProvider(
            this.$axiosHttp,
            "brokers/" + this.broker.Id + "/draft-plans",
            this.headers
          );
        }
      },
    },
    planType: {
      handler(v) {
        if (v) {
          this.uploadURL =
            this.settings.APIURL +
            "builder/draft-plans/" +
            this.broker.Id +
            "/import/" +
            v;
        }
      },
    },
    options: {
      handler(v) {
        console.log("options: ", this.options);
        if (v) {
          this.$nextTick(() => {
            this.headers = getPlansHeaders(this.options);
          });
        }
      },
    },
  },
  async mounted() {
    console.log("mounted: ", this.options, this.broker);
    try {
      this.broker = (await this.getOrganizationById({
        id: this.$route.params.broker,
      })).data;
    } catch (error) {
      this.error = error;
    }
    console.log("mounted 2: ", this.options, this.broker);
    if (this.options) {
      this.headers = getPlansHeaders(this.options);
    }
  },
  methods: {
    ...mapActions("plansMembers", [
      "createPlan",
      "getPlanById",
      "deleteDraft",
      "getOrganizationById",
      "activatePlan",
      "makeDraft",
      "clearData",
      "saveDraft",
      "exportPlan",
      "testPlan",
    ]),
    ...mapActions("common", ["setPlan"]),
    ...mapActions("auth", ["getRoles", "getUser"]),
    closeImport() {
      this.dialogs.import = false;
      if (this.uploadedOK) {
        this.$refs.table.getDataAsync();
      }
    },
    async tryExport(item) {
      this.loading = true;
      try {
        let data = (await this.exportPlan({ draftId: item.Id })).data;
        this.downloadObjectAsJson(data, item.UniqueIdentifier);
        this.color = "success";
        this.message = this.$t("views.planwizardview.clear_data_success_{0}", [
          item.UniqueIdentifier,
        ]);
        this.snackbar = true;
      } catch (e) {
        this.error = e;
      } finally {
        this.loading = false;
      }
    },
    downloadObjectAsJson(exportObj, exportName) {
      var dataStr =
        "data:text/json;charset=utf-8," +
        encodeURIComponent(JSON.stringify(exportObj));
      var downloadAnchorNode = document.createElement("a");
      downloadAnchorNode.setAttribute("href", dataStr);
      downloadAnchorNode.setAttribute("download", exportName + ".json");
      document.body.appendChild(downloadAnchorNode); // required for firefox
      downloadAnchorNode.click();
      downloadAnchorNode.remove();
    },
    onUploadStarted() {
      this.uploaded = false;
      this.uploading = true;
    },
    onUploadCompleted(res) {
      this.uploaded = true;
      this.uploadedOK = true;
      this.uploading = false;
    },
    onUploadError(err) {
      this.uploaded = true;
      this.uploadedOK = false;
      this.uploading = false;
      if (Array.isArray(err.response.data)) {
        this.error = err.response.data.join(", ");
      } else {
        this.error = err;
      }
    },
    async removePlan() {
      this.saving = true;
      try {
        await this.deleteDraft(this.planId);
        this.$refs.table.getDataAsync();
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.planId = null;
        this.dialogs.delete = false;
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },

    async finalize() {
      this.saving = true;
      let item = JSON.parse(JSON.stringify(this.selectedItem));
      try {
        await this.lock(this.activatePlan, {
          broker: this.broker.Id,
          plan: item.Id,
        },
        null,
        false,
        true);
        // await this.activatePlan({
        //   broker: this.broker.Id,
        //   plan: item.Id,
        // });
        this.color = "success";
        this.message = this.$t("views.planwizardview.activate_success_{0}", [
          item.UniqueIdentifier,
        ]);
        this.snackbar = true;
        this.selectedItem = null;
        this.dialogs.activateWarning = false;
        this.$refs.table.getDataAsync();
        this.setPlan(null);
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
        this.unlock();
      }
    },
    async tryMakeDraft() {
      this.saving = true;
      let item = JSON.parse(JSON.stringify(this.selectedItem));
      try {
        await this.makeDraft({
          broker: this.broker.Id,
          plan: item.Id,
        });
        this.color = "success";
        this.message = this.$t("views.planwizardview.make_draft_success_{0}", [
          item.UniqueIdentifier,
        ]);
        this.snackbar = true;
        this.selectedItem = null;
        this.dialogs.draftWarning = false;
        this.$refs.table.getDataAsync();
        this.setPlan(null);
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
    async tryMakeDraftLive() {
      this.saving = true;
      let item = JSON.parse(JSON.stringify(this.selectedItem));
      try {
        await this.makeDraft({
          broker: this.broker.Id,
          plan: item.Id,
        });
        this.color = "success";
        this.message = this.$t("views.planwizardview.make_draft_success_{0}", [
          item.UniqueIdentifier,
        ]);
        this.snackbar = true;
        this.selectedItem = null;
        this.dialogs.clearDataWarning = false;
        this.$refs.table.getDataAsync();
        this.setPlan(null);
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
    async tryClearData() {
      let item = this.selectedItem;
      this.loading = true;
      try {
        await this.clearData({ broker: this.broker.Id, plan: item.Id });
        this.color = "success";
        this.message = this.$t("views.planwizardview.clear_data_success_{0}", [
          item.UniqueIdentifier,
        ]);
        this.snackbar = true;
        this.dialogs.clearDataWarning = false;
      } catch (e) {
        this.error = e;
      } finally {
        this.loading = false;
      }
    },
    async testDraft() {
      this.saving = true;
      try {
        await this.lock(this.testPlan, {
          broker: this.broker.Id,
          plan: this.selectedItem.Id,
        },
        null,
        false,
        true);
        // await this.testPlan({
        //   broker: this.broker.Id,
        //   plan: this.selectedItem.Id,
        // });
        this.color = "success";
        this.message = this.$t("views.planwizardview.test_success_{0}", [
          this.selectedItem.UniqueIdentifier,
        ]);
        this.snackbar = true;
        this.dialogs.testWarning = false;
        this.$refs.table.getDataAsync();
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
        this.unlock();
      }
    },
  },
};
</script>
